import { motion } from "framer-motion";
import ContactForm from "./ContactForm";

export default function FinalCTA({ initialService = "general" }) {
  return (
    <section
      id="contact"
      data-testid="final-cta-section"
      className="relative py-20 md:py-40 bg-[#030303] overflow-hidden"
    >
      {/* soft gold glow */}
      <div
        aria-hidden
        className="pointer-events-none absolute -top-40 left-1/2 -translate-x-1/2 w-[600px] md:w-[900px] h-[600px] md:h-[900px] rounded-full"
        style={{
          background:
            "radial-gradient(closest-side, rgba(212,175,55,0.18), rgba(212,175,55,0) 65%)",
        }}
      />

      <div className="relative max-w-[1440px] mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.9 }}
          className="text-center max-w-4xl mx-auto"
        >
          <div className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] mb-5 md:mb-6">
            Ch. 10 &mdash; The Ask
          </div>
          <h2 className="font-display text-white text-[32px] sm:text-4xl md:text-6xl lg:text-[88px] leading-[1.02] sm:leading-[0.98] tracking-[-0.02em]">
            Your nightclub doesn't need{" "}
            <em className="font-editorial italic text-white/40 font-light">
              more guests.
            </em>
            <br />
            It needs{" "}
            <em className="font-editorial italic text-[#D4AF37] font-light">
              better systems.
            </em>
          </h2>
          <p className="mt-6 md:mt-8 text-white/70 max-w-xl mx-auto text-base md:text-lg">
            Tell me a little about your venue. I'll reply personally within 24
            hours.
          </p>
        </motion.div>

        <div className="mt-12 md:mt-16 max-w-4xl mx-auto">
          <ContactForm initialService={initialService} />
        </div>
      </div>
    </section>
  );
}
